// extracted by mini-css-extract-plugin
export default {"container":"nfl-ended_container__2ksin","pill":"nfl-ended_pill__1HucX","title":"nfl-ended_title__3HaoE","description":"nfl-ended_description__1ct67"};